import type { ReactNode } from "react";
import Typography from "@mui/material/Typography";
import { ERROR_TEXT_SX } from "../constants";

type FieldErrorProps = {
  children: ReactNode;
};

export function FieldError({ children }: FieldErrorProps) {
  return <Typography sx={ERROR_TEXT_SX}>{children}</Typography>;
}
